<template>
  <div>
    <v-dialog v-model='deleteDialog' ref='deleteDialog' max-width='500px'>
      <v-card>
        <v-card-title class='headline font-weight-regular oem-color'>
          {{ title }}
        </v-card-title>
        <v-card-text>
          {{ msg }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class='oem-button' flat @click='cancel()'>
            Cancel
          </v-btn>
          <v-btn class='oem-button' flat @click='confirm()'>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    msg: String,
  },

  data() {
    return {
      deleteDialog: false,
      deleteName: '',
      promise: null,
      resolve: null,
      reject: null,
    };
  },

  methods: {
    pop() {
      this.deleteDialog = true;
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      return this.promise;
    },
    confirm() {
      this.deleteDialog = false;
      this.resolve();
    },
    cancel() {
      this.deleteDialog = false;
      this.reject();
    },
  },
};
</script>
